import styled from '@emotion/styled';

export const TilesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 0 -15px;
`;
